import React from "react";
import styles from "./styles.module.scss";
import { get } from "lodash";
import cx from "classnames";

const BookingStatus = ({ bookingInfo }) => {
  const status = get(bookingInfo, "status", 1);
  const partner = get(bookingInfo, "partner");
  const bookingStatusStyle = get(bookingInfo, "bookingStatusStyle");
  const description = get(bookingInfo, "description");
  const cancelMessage = get(bookingInfo, "cancelMessage", "");
  const classGreen = styles.greenNote;
  const classRed = styles.redNote;
  const classGrey = styles.greyNote;

  const classTimeNote = cx({
    [classGreen]: true,
    [classRed]: [0, 6].includes(status),
    [classGrey]: [-2].includes(status)
  });

  return (
    <div className={styles["printBillCode"]}>
      <p className={styles.sub_title}>PHIẾU KHÁM BỆNH</p>

      {bookingInfo?.totalPaymentMessage && (
        <div
          className={styles.noteTrungVuong}
          style={{
            background: bookingStatusStyle?.background || "#F26F21",
            padding: "8px"
          }}
        >
          {bookingInfo?.totalPaymentMessage}
          <p className={styles.note}>{bookingInfo?.totalMessageExtra}</p>
        </div>
      )}
      <div className={cx(styles.status)}>
        <span
          style={bookingStatusStyle || {}}
          className={cx(styles.description, classTimeNote)}
        >
          {description}
        </span>
      </div>
      {cancelMessage && (
        <p className={styles.cancelMessage}>{cancelMessage}</p>
      )}
    </div>
  );
};

export default BookingStatus;
